import type { SendbirdGroupChannel } from '@sendbird/uikit-utils';
import { CHANNEL_CUSTOM_TYPE } from '@shared/constants/chatChannels';
import type { TChannelKind } from '../types';

export const getChannelKind = (channel: Pick<SendbirdGroupChannel, 'customType'>): TChannelKind => {
    switch (channel.customType) {
        case CHANNEL_CUSTOM_TYPE.clinical:
            return 'clinical';
        case CHANNEL_CUSTOM_TYPE.technicalSupport:
            return 'technicalSupport';
        default:
            return 'other';
    }
};
